import { z } from "zod"

export enum StripeErrorCode {
  ACCOUNT_CLOSED = "ACCOUNT_CLOSED",
  ACCOUNT_COUNTRY_INVALID_ADDRESS = "ACCOUNT_COUNTRY_INVALID_ADDRESS",
  ACCOUNT_ERROR_COUNTRY_CHANGE_REQUIRES_ADDITIONAL_STEPS = "ACCOUNT_ERROR_COUNTRY_CHANGE_REQUIRES_ADDITIONAL_STEPS",
  ACCOUNT_INFORMATION_MISMATCH = "ACCOUNT_INFORMATION_MISMATCH",
  ACCOUNT_INVALID = "ACCOUNT_INVALID",
  ACCOUNT_NUMBER_INVALID = "ACCOUNT_NUMBER_INVALID",
  ACSS_DEBIT_SESSION_INCOMPLETE = "ACSS_DEBIT_SESSION_INCOMPLETE",
  ALIPAY_UPGRADE_REQUIRED = "ALIPAY_UPGRADE_REQUIRED",
  AMOUNT_TOO_LARGE = "AMOUNT_TOO_LARGE",
  AMOUNT_TOO_SMALL = "AMOUNT_TOO_SMALL",
  API_KEY_EXPIRED = "API_KEY_EXPIRED",
  APPLICATION_FEES_NOT_ALLOWED = "APPLICATION_FEES_NOT_ALLOWED",
  AUTHENTICATION_REQUIRED = "AUTHENTICATION_REQUIRED",
  BALANCE_INSUFFICIENT = "BALANCE_INSUFFICIENT",
  BALANCE_INVALID_PARAMETER = "BALANCE_INVALID_PARAMETER",
  BANK_ACCOUNT_BAD_ROUTING_NUMBERS = "BANK_ACCOUNT_BAD_ROUTING_NUMBERS",
  BANK_ACCOUNT_DECLINED = "BANK_ACCOUNT_DECLINED",
  BANK_ACCOUNT_EXISTS = "BANK_ACCOUNT_EXISTS",
  BANK_ACCOUNT_RESTRICTED = "BANK_ACCOUNT_RESTRICTED",
  BANK_ACCOUNT_UNUSABLE = "BANK_ACCOUNT_UNUSABLE",
  BANK_ACCOUNT_UNVERIFIED = "BANK_ACCOUNT_UNVERIFIED",
  BANK_ACCOUNT_VERIFICATION_FAILED = "BANK_ACCOUNT_VERIFICATION_FAILED",
  BILLING_INVALID_MANDATE = "BILLING_INVALID_MANDATE",
  BITCOIN_UPGRADE_REQUIRED = "BITCOIN_UPGRADE_REQUIRED",
  CAPTURE_CHARGE_AUTHORIZATION_EXPIRED = "CAPTURE_CHARGE_AUTHORIZATION_EXPIRED",
  CAPTURE_UNAUTHORIZED_PAYMENT = "CAPTURE_UNAUTHORIZED_PAYMENT",
  CARD_DECLINE_RATE_LIMIT_EXCEEDED = "CARD_DECLINE_RATE_LIMIT_EXCEEDED",
  CARD_DECLINED = "CARD_DECLINED",
  CARDHOLDER_PHONE_NUMBER_REQUIRED = "CARDHOLDER_PHONE_NUMBER_REQUIRED",
  CHARGE_ALREADY_CAPTURED = "CHARGE_ALREADY_CAPTURED",
  CHARGE_ALREADY_REFUNDED = "CHARGE_ALREADY_REFUNDED",
  CHARGE_DISPUTED = "CHARGE_DISPUTED",
  CHARGE_EXCEEDS_SOURCE_LIMIT = "CHARGE_EXCEEDS_SOURCE_LIMIT",
  CHARGE_EXPIRED_FOR_CAPTURE = "CHARGE_EXPIRED_FOR_CAPTURE",
  CHARGE_INVALID_PARAMETER = "CHARGE_INVALID_PARAMETER",
  CHARGE_NOT_REFUNDABLE = "CHARGE_NOT_REFUNDABLE",
  CLEARING_CODE_UNSUPPORTED = "CLEARING_CODE_UNSUPPORTED",
  COUNTRY_CODE_INVALID = "COUNTRY_CODE_INVALID",
  COUNTRY_UNSUPPORTED = "COUNTRY_UNSUPPORTED",
  COUPON_EXPIRED = "COUPON_EXPIRED",
  CUSTOMER_MAX_PAYMENT_METHODS = "CUSTOMER_MAX_PAYMENT_METHODS",
  CUSTOMER_MAX_SUBSCRIPTIONS = "CUSTOMER_MAX_SUBSCRIPTIONS",
  CUSTOMER_TAX_LOCATION_INVALID = "CUSTOMER_TAX_LOCATION_INVALID",
  DEBIT_NOT_AUTHORIZED = "DEBIT_NOT_AUTHORIZED",
  EMAIL_INVALID = "EMAIL_INVALID",
  EXPIRED_CARD = "EXPIRED_CARD",
  FINANCIAL_CONNECTIONS_ACCOUNT_INACTIVE = "FINANCIAL_CONNECTIONS_ACCOUNT_INACTIVE",
  FINANCIAL_CONNECTIONS_NO_SUCCESSFUL_TRANSACTION_REFRESH = "FINANCIAL_CONNECTIONS_NO_SUCCESSFUL_TRANSACTION_REFRESH",
  FORWARDING_API_INACTIVE = "FORWARDING_API_INACTIVE",
  FORWARDING_API_INVALID_PARAMETER = "FORWARDING_API_INVALID_PARAMETER",
  FORWARDING_API_UPSTREAM_CONNECTION_ERROR = "FORWARDING_API_UPSTREAM_CONNECTION_ERROR",
  FORWARDING_API_UPSTREAM_CONNECTION_TIMEOUT = "FORWARDING_API_UPSTREAM_CONNECTION_TIMEOUT",
  IDEMPOTENCY_KEY_IN_USE = "IDEMPOTENCY_KEY_IN_USE",
  INCORRECT_ADDRESS = "INCORRECT_ADDRESS",
  INCORRECT_CVC = "INCORRECT_CVC",
  INCORRECT_NUMBER = "INCORRECT_NUMBER",
  INCORRECT_ZIP = "INCORRECT_ZIP",
  INSTANT_PAYOUTS_CONFIG_DISABLED = "INSTANT_PAYOUTS_CONFIG_DISABLED",
  INSTANT_PAYOUTS_CURRENCY_DISABLED = "INSTANT_PAYOUTS_CURRENCY_DISABLED",
  INSTANT_PAYOUTS_LIMIT_EXCEEDED = "INSTANT_PAYOUTS_LIMIT_EXCEEDED",
  INSTANT_PAYOUTS_UNSUPPORTED = "INSTANT_PAYOUTS_UNSUPPORTED",
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  INTENT_INVALID_STATE = "INTENT_INVALID_STATE",
  INTENT_VERIFICATION_METHOD_MISSING = "INTENT_VERIFICATION_METHOD_MISSING",
  INVALID_CARD_TYPE = "INVALID_CARD_TYPE",
  INVALID_CHARACTERS = "INVALID_CHARACTERS",
  INVALID_CHARGE_AMOUNT = "INVALID_CHARGE_AMOUNT",
  INVALID_CVC = "INVALID_CVC",
  INVALID_EXPIRY_MONTH = "INVALID_EXPIRY_MONTH",
  INVALID_EXPIRY_YEAR = "INVALID_EXPIRY_YEAR",
  INVALID_NUMBER = "INVALID_NUMBER",
  INVALID_SOURCE_USAGE = "INVALID_SOURCE_USAGE",
  INVALID_TAX_LOCATION = "INVALID_TAX_LOCATION",
  INVOICE_NO_CUSTOMER_LINE_ITEMS = "INVOICE_NO_CUSTOMER_LINE_ITEMS",
  INVOICE_NO_PAYMENT_METHOD_TYPES = "INVOICE_NO_PAYMENT_METHOD_TYPES",
  INVOICE_NO_SUBSCRIPTION_LINE_ITEMS = "INVOICE_NO_SUBSCRIPTION_LINE_ITEMS",
  INVOICE_NOT_EDITABLE = "INVOICE_NOT_EDITABLE",
  INVOICE_ON_BEHALF_OF_NOT_EDITABLE = "INVOICE_ON_BEHALF_OF_NOT_EDITABLE",
  INVOICE_PAYMENT_INTENT_REQUIRES_ACTION = "INVOICE_PAYMENT_INTENT_REQUIRES_ACTION",
  INVOICE_UPCOMING_NONE = "INVOICE_UPCOMING_NONE",
  LIVEMODE_MISMATCH = "LIVEMODE_MISMATCH",
  LOCK_TIMEOUT = "LOCK_TIMEOUT",
  MISSING = "MISSING",
  NO_ACCOUNT = "NO_ACCOUNT",
  NOT_ALLOWED_ON_STANDARD_ACCOUNT = "NOT_ALLOWED_ON_STANDARD_ACCOUNT",
  OUT_OF_INVENTORY = "OUT_OF_INVENTORY",
  OWNERSHIP_DECLARATION_NOT_ALLOWED = "OWNERSHIP_DECLARATION_NOT_ALLOWED",
  PARAMETER_INVALID_EMPTY = "PARAMETER_INVALID_EMPTY",
  PARAMETER_INVALID_INTEGER = "PARAMETER_INVALID_INTEGER",
  PARAMETER_INVALID_STRING_BLANK = "PARAMETER_INVALID_STRING_BLANK",
  PARAMETER_INVALID_STRING_EMPTY = "PARAMETER_INVALID_STRING_EMPTY",
  PARAMETER_MISSING = "PARAMETER_MISSING",
  PARAMETER_UNKNOWN = "PARAMETER_UNKNOWN",
  PARAMETERS_EXCLUSIVE = "PARAMETERS_EXCLUSIVE",
  PAYMENT_INTENT_ACTION_REQUIRED = "PAYMENT_INTENT_ACTION_REQUIRED",
  PAYMENT_INTENT_AUTHENTICATION_FAILURE = "PAYMENT_INTENT_AUTHENTICATION_FAILURE",
  PAYMENT_INTENT_INCOMPATIBLE_PAYMENT_METHOD = "PAYMENT_INTENT_INCOMPATIBLE_PAYMENT_METHOD",
  PAYMENT_INTENT_INVALID_PARAMETER = "PAYMENT_INTENT_INVALID_PARAMETER",
  PAYMENT_INTENT_KONBINI_REJECTED_CONFIRMATION_NUMBER = "PAYMENT_INTENT_KONBINI_REJECTED_CONFIRMATION_NUMBER",
  PAYMENT_INTENT_MANDATE_INVALID = "PAYMENT_INTENT_MANDATE_INVALID",
  PAYMENT_INTENT_PAYMENT_ATTEMPT_EXPIRED = "PAYMENT_INTENT_PAYMENT_ATTEMPT_EXPIRED",
  PAYMENT_INTENT_PAYMENT_ATTEMPT_FAILED = "PAYMENT_INTENT_PAYMENT_ATTEMPT_FAILED",
  PAYMENT_INTENT_UNEXPECTED_STATE = "PAYMENT_INTENT_UNEXPECTED_STATE",
  PAYMENT_METHOD_BANK_ACCOUNT_ALREADY_VERIFIED = "PAYMENT_METHOD_BANK_ACCOUNT_ALREADY_VERIFIED",
  PAYMENT_METHOD_BANK_ACCOUNT_BLOCKED = "PAYMENT_METHOD_BANK_ACCOUNT_BLOCKED",
  PAYMENT_METHOD_BILLING_DETAILS_ADDRESS_MISSING = "PAYMENT_METHOD_BILLING_DETAILS_ADDRESS_MISSING",
  PAYMENT_METHOD_CONFIGURATION_FAILURES = "PAYMENT_METHOD_CONFIGURATION_FAILURES",
  PAYMENT_METHOD_CURRENCY_MISMATCH = "PAYMENT_METHOD_CURRENCY_MISMATCH",
  PAYMENT_METHOD_CUSTOMER_DECLINE = "PAYMENT_METHOD_CUSTOMER_DECLINE",
  PAYMENT_METHOD_INVALID_PARAMETER = "PAYMENT_METHOD_INVALID_PARAMETER",
  PAYMENT_METHOD_INVALID_PARAMETER_TESTMODE = "PAYMENT_METHOD_INVALID_PARAMETER_TESTMODE",
  PAYMENT_METHOD_MICRODEPOSIT_FAILED = "PAYMENT_METHOD_MICRODEPOSIT_FAILED",
  PAYMENT_METHOD_MICRODEPOSIT_VERIFICATION_AMOUNTS_INVALID = "PAYMENT_METHOD_MICRODEPOSIT_VERIFICATION_AMOUNTS_INVALID",
  PAYMENT_METHOD_MICRODEPOSIT_VERIFICATION_AMOUNTS_MISMATCH = "PAYMENT_METHOD_MICRODEPOSIT_VERIFICATION_AMOUNTS_MISMATCH",
  PAYMENT_METHOD_MICRODEPOSIT_VERIFICATION_ATTEMPTS_EXCEEDED = "PAYMENT_METHOD_MICRODEPOSIT_VERIFICATION_ATTEMPTS_EXCEEDED",
  PAYMENT_METHOD_MICRODEPOSIT_VERIFICATION_DESCRIPTOR_CODE_MISMATCH = "PAYMENT_METHOD_MICRODEPOSIT_VERIFICATION_DESCRIPTOR_CODE_MISMATCH",
  PAYMENT_METHOD_MICRODEPOSIT_VERIFICATION_TIMEOUT = "PAYMENT_METHOD_MICRODEPOSIT_VERIFICATION_TIMEOUT",
  PAYMENT_METHOD_NOT_AVAILABLE = "PAYMENT_METHOD_NOT_AVAILABLE",
  PAYMENT_METHOD_PROVIDER_DECLINE = "PAYMENT_METHOD_PROVIDER_DECLINE",
  PAYMENT_METHOD_PROVIDER_TIMEOUT = "PAYMENT_METHOD_PROVIDER_TIMEOUT",
  PAYMENT_METHOD_UNACTIVATED = "PAYMENT_METHOD_UNACTIVATED",
  PAYMENT_METHOD_UNEXPECTED_STATE = "PAYMENT_METHOD_UNEXPECTED_STATE",
  PAYMENT_METHOD_UNSUPPORTED_TYPE = "PAYMENT_METHOD_UNSUPPORTED_TYPE",
  PAYOUT_RECONCILIATION_NOT_READY = "PAYOUT_RECONCILIATION_NOT_READY",
  PAYOUTS_LIMIT_EXCEEDED = "PAYOUTS_LIMIT_EXCEEDED",
  PAYOUTS_NOT_ALLOWED = "PAYOUTS_NOT_ALLOWED",
  PLATFORM_ACCOUNT_REQUIRED = "PLATFORM_ACCOUNT_REQUIRED",
  PLATFORM_API_KEY_EXPIRED = "PLATFORM_API_KEY_EXPIRED",
  POSTAL_CODE_INVALID = "POSTAL_CODE_INVALID",
  PROCESSING_ERROR = "PROCESSING_ERROR",
  PRODUCT_INACTIVE = "PRODUCT_INACTIVE",
  PROGRESSIVE_ONBOARDING_LIMIT_EXCEEDED = "PROGRESSIVE_ONBOARDING_LIMIT_EXCEEDED",
  RATE_LIMIT = "RATE_LIMIT",
  REFER_TO_CUSTOMER = "REFER_TO_CUSTOMER",
  REFUND_DISPUTED_PAYMENT = "REFUND_DISPUTED_PAYMENT",
  RESOURCE_ALREADY_EXISTS = "RESOURCE_ALREADY_EXISTS",
  RESOURCE_MISSING = "RESOURCE_MISSING",
  RETURN_INTENT_ALREADY_PROCESSED = "RETURN_INTENT_ALREADY_PROCESSED",
  ROUTING_NUMBER_INVALID = "ROUTING_NUMBER_INVALID",
  SECRET_KEY_REQUIRED = "SECRET_KEY_REQUIRED",
  SEPA_UNSUPPORTED_ACCOUNT = "SEPA_UNSUPPORTED_ACCOUNT",
  SETUP_ATTEMPT_FAILED = "SETUP_ATTEMPT_FAILED",
  SETUP_INTENT_AUTHENTICATION_FAILURE = "SETUP_INTENT_AUTHENTICATION_FAILURE",
  SETUP_INTENT_INVALID_PARAMETER = "SETUP_INTENT_INVALID_PARAMETER",
  SETUP_INTENT_MANDATE_INVALID = "SETUP_INTENT_MANDATE_INVALID",
  SETUP_INTENT_SETUP_ATTEMPT_EXPIRED = "SETUP_INTENT_SETUP_ATTEMPT_EXPIRED",
  SETUP_INTENT_UNEXPECTED_STATE = "SETUP_INTENT_UNEXPECTED_STATE",
  SHIPPING_CALCULATION_FAILED = "SHIPPING_CALCULATION_FAILED",
  SKU_INACTIVE = "SKU_INACTIVE",
  STATE_UNSUPPORTED = "STATE_UNSUPPORTED",
  STATUS_TRANSITION_INVALID = "STATUS_TRANSITION_INVALID",
  STRIPE_TAX_INACTIVE = "STRIPE_TAX_INACTIVE",
  TAX_ID_INVALID = "TAX_ID_INVALID",
  TAXES_CALCULATION_FAILED = "TAXES_CALCULATION_FAILED",
  TERMINAL_LOCATION_COUNTRY_UNSUPPORTED = "TERMINAL_LOCATION_COUNTRY_UNSUPPORTED",
  TERMINAL_READER_BUSY = "TERMINAL_READER_BUSY",
  TERMINAL_READER_HARDWARE_FAULT = "TERMINAL_READER_HARDWARE_FAULT",
  TERMINAL_READER_OFFLINE = "TERMINAL_READER_OFFLINE",
  TERMINAL_READER_TIMEOUT = "TERMINAL_READER_TIMEOUT",
  TESTMODE_CHARGES_ONLY = "TESTMODE_CHARGES_ONLY",
  TLS_VERSION_UNSUPPORTED = "TLS_VERSION_UNSUPPORTED",
  TOKEN_ALREADY_USED = "TOKEN_ALREADY_USED",
  TOKEN_CARD_NETWORK_INVALID = "TOKEN_CARD_NETWORK_INVALID",
  TOKEN_IN_USE = "TOKEN_IN_USE",
  TRANSFER_SOURCE_BALANCE_PARAMETERS_MISMATCH = "TRANSFER_SOURCE_BALANCE_PARAMETERS_MISMATCH",
  TRANSFERS_NOT_ALLOWED = "TRANSFERS_NOT_ALLOWED",
  URL_INVALID = "URL_INVALID",
  REQUIRES_PAYMENT_METHOD = "REQUIRES_PAYMENT_METHOD",
  APPROVE_WITH_ID = "APPROVE_WITH_ID",
  CALL_ISSUER = "CALL_ISSUER",
  CARD_NOT_SUPPORTED = "CARD_NOT_SUPPORTED",
  CARD_VELOCITY_EXCEEDED = "CARD_VELOCITY_EXCEEDED",
  CURRENCY_NOT_SUPPORTED = "CURRENCY_NOT_SUPPORTED",
  DO_NOT_HONOR = "DO_NOT_HONOR",
  DO_NOT_TRY_AGAIN = "DO_NOT_TRY_AGAIN",
  DUPLICATE_TRANSACTION = "DUPLICATE_TRANSACTION",
  FRAUDULENT = "FRAUDULENT",
  GENERIC_DECLINE = "GENERIC_DECLINE",
  ISSUER_NOT_AVAILABLE = "ISSUER_NOT_AVAILABLE",
  LOST_CARD = "LOST_CARD",
  MERCHANT_BLACKLIST = "MERCHANT_BLACKLIST",
  NEW_ACCOUNT_INFORMATION_AVAILABLE = "NEW_ACCOUNT_INFORMATION_AVAILABLE",
  NO_ACTION_TAKEN = "NO_ACTION_TAKEN",
  NOT_PERMITTED = "NOT_PERMITTED",
  OFFLINE_PIN_REQUIRED = "OFFLINE_PIN_REQUIRED",
  ONLINE_OR_OFFLINE_PIN_REQUIRED = "ONLINE_OR_OFFLINE_PIN_REQUIRED",
  PICKUP_CARD = "PICKUP_CARD",
  PIN_TRY_EXCEEDED = "PIN_TRY_EXCEEDED",
  REENTER_TRANSACTION = "REENTER_TRANSACTION",
  RESTRICTED_CARD = "RESTRICTED_CARD",
  REVOCATION_OF_ALL_AUTHORIZATIONS = "REVOCATION_OF_ALL_AUTHORIZATIONS",
  REVOCATION_OF_AUTHORIZATION = "REVOCATION_OF_AUTHORIZATION",
  SECURITY_VIOLATION = "SECURITY_VIOLATION",
  SERVICE_NOT_ALLOWED = "SERVICE_NOT_ALLOWED",
  STOLEN_CARD = "STOLEN_CARD",
  STOP_PAYMENT_ORDER = "STOP_PAYMENT_ORDER",
  TESTMODE_DECLINE = "TESTMODE_DECLINE",
  TRANSACTION_NOT_ALLOWED = "TRANSACTION_NOT_ALLOWED",
  TRY_AGAIN_LATER = "TRY_AGAIN_LATER",
  WITHDRAWAL_COUNT_LIMIT_EXCEEDED = "WITHDRAWAL_COUNT_LIMIT_EXCEEDED",
  UNKNOWN = "UNKNOWN",
}
export enum StripeAccountErrorCode {
  IS_MISSING_DOCUMENT = "IS_MISSING_DOCUMENT",
  UNKNOWN = "UNKNOWN",
}

export const PaymentErrorDtoSchema = z.object({
  errorCode: z.nativeEnum(StripeErrorCode),
  declineCode: z.nativeEnum(StripeErrorCode).nullable(),
  last4Digits: z.string().nullable(),
  subscriptionName: z.string(),
  programId: z.string().nullable(),
  boxOfferId: z.string().nullable(),
  boxId: z.string().nullable(),
  boxSubscriptionId: z.string().nullable(),
  programSubscriptionId: z.string().nullable(),
  programBundleSubscriptionId: z.string().nullable(),
  programBundleId: z.string().nullable(),
})

export type PaymentErrorDto = z.infer<typeof PaymentErrorDtoSchema>
export type PaymentError = PaymentErrorDto

export const StripeErrorsDtoSchema = z.object({
  paymentErrors: z.array(PaymentErrorDtoSchema),
  accountError: z.nativeEnum(StripeAccountErrorCode).nullable(),
})

export type StripeErrorsDto = z.infer<typeof StripeErrorsDtoSchema>
export type StripeErrors = StripeErrorsDto
